export default __webpack_public_path__ + "static/media/rankpage-top2.b4067a30.svg";